import React from 'react';
type DecorProps = {
  className?: string;
};

/** Rama botánica con hojas — decorativa. */
export function Sprig({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 120 200" fill="none" aria-hidden="true" className={className} data-id="element-75" data-mp="3sagy3nwtem4g">
      <path d="M60 196V16" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" data-id="element-76" data-mp="3eewppmeppmba" />
      {[0, 1, 2, 3, 4].map(index => {
      const y = 44 + index * 30;
      return <g key={index} data-id="element-77" data-mp="awved3a1dtgd">
            <path d={`M60 ${y} C40 ${y - 16} 20 ${y - 10} 12 ${y + 6} C30 ${y + 18} 50 ${y + 12} 60 ${y}Z`} fill="currentColor" opacity="0.35" data-id="element-78" data-mp="aypmti44ft3k" />
            <path d={`M60 ${y + 14} C80 ${y - 2} 100 ${y + 4} 108 ${y + 20} C90 ${y + 32} 70 ${y + 26} 60 ${y + 14}Z`} fill="currentColor" opacity="0.22" data-id="element-79" data-mp="14pmdtjsbc16" />
          </g>;
    })}
      <circle cx="60" cy="16" r="7" fill="currentColor" opacity="0.5" data-id="element-80" data-mp="ym64zrxoa7gs" />
    </svg>;
}

/** Flor de cinco pétalos — decorativa. */
export function Blossom({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 100 100" fill="none" aria-hidden="true" className={className} data-id="element-81" data-mp="3b801wb5016of">
      {[0, 1, 2, 3, 4].map(index => <ellipse key={index} cx="50" cy="26" rx="14" ry="22" fill="currentColor" opacity="0.4" transform={`rotate(${index * 72} 50 50)`} data-id="element-82" data-mp="3p06g3rold3l8" />)}
      <circle cx="50" cy="50" r="9" fill="currentColor" opacity="0.75" data-id="element-83" data-mp="2t88x08vea5z" />
    </svg>;
}

/** Frasco gotero de esencia floral — decorativo. */
export function DropperBottle({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 80 160" fill="none" aria-hidden="true" className={className} data-id="element-84" data-mp="6t8nckvyyld1">
      <rect x="30" y="6" width="20" height="34" rx="5" fill="currentColor" opacity="0.75" data-id="element-85" data-mp="2djgi2vubni2p" />
      <rect x="24" y="36" width="32" height="14" rx="4" fill="currentColor" opacity="0.9" data-id="element-86" data-mp="2dl9oqb4xq2ap" />
      <path d="M26 50h28c6 0 10 5 10 11v82c0 6-4 11-10 11H26c-6 0-10-5-10-11V61c0-6 4-11 10-11Z" fill="currentColor" opacity="0.32" data-id="element-87" data-mp="28mg7q8qfvt5s" />
      <rect x="24" y="86" width="32" height="34" rx="4" fill="currentColor" opacity="0.22" data-id="element-88" data-mp="hh3axuvczd3n" />
      <path d="M40 130c4-7 7-11 7-15a7 7 0 1 0-14 0c0 4 3 8 7 15Z" fill="currentColor" opacity="0.6" data-id="element-89" data-mp="mebthwkf5j5f" />
    </svg>;
}